<ng-container *ngIf="datalink$ | async as datalink">
    <div class="page-container page-container-vertical">
        <isav-unpublished-warning
            [published]="!datalink.draft"
            contentName="Data-Link"
            myContentPath="my-datalinks"
        ></isav-unpublished-warning>
        <isav-notes *isavAuthenticated="true" [iri]="datalink['@id']"></isav-notes>
        <isav-add-note [(hidden)]="hidden" [contentIri]="datalink['@id']"></isav-add-note>
        <isav-action-title
            [title]="datalink.fullNameOfDataSet | isavTitleFallback : datalink['@id']"
        >
            <a
                *isavHasEditAccess="datalink['@id']"
                [isavEditLink]="datalink"
                isavEditLinkProperty="fullNameOfDataSet"
                isavBtn
                color="primary"
            >
                Edit
            </a>
            <button
                *isavHasCreateAccess="'Datalink'"
                [isavCloneContent]="datalink['@id']"
                isavBtn
                color="primary"
            >
                Clone
            </button>
            <button
                (click)="writeNote()"
                *isavAuthenticated="true"
                type="button"
                isavBtn
                color="primary"
            >
                Write note
            </button>
            <button isavBtn color="primary" isavPrintPage>Print page</button>
        </isav-action-title>
    </div>

    <isav-content-type-view [isVerticalInPrint]="true">
        <isav-caption> Data Information </isav-caption>
        <div isavContentTypeDetails>
            <p>
                <strong>Organisation: </strong>
                <isav-taxonomies-external-link
                    [iris]="[datalink.organisation]"
                ></isav-taxonomies-external-link>
            </p>
            <p>
                <strong>Departments: </strong>
                <isav-taxonomies-external-link
                    [iris]="datalink.departments"
                ></isav-taxonomies-external-link>
            </p>
            <p *ngIf="datalink.linkToDataAccessPage">
                <strong>Link to data access page: </strong>
                <isav-external-link [link]="datalink.linkToDataAccessPage"></isav-external-link>
            </p>
            <p>
                <strong>Format: </strong>
                <isav-taxonomies-names [iris]="[datalink.format]"></isav-taxonomies-names>
            </p>

            <p><strong>Keywords: </strong> {{ datalink.keywords }}</p>
            <p><strong>Start Date: </strong> {{ datalink.startDate | isavDate}}</p>
            <p><strong>End Date: </strong> {{ datalink.endDate | isavDate }}</p>
            <p>
                <strong>Theme: </strong>
                <isav-taxonomies-names [iris]="[datalink.theme]"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Topics: </strong>
                <isav-taxonomies-names [iris]="datalink.topics"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Country: </strong>
                <isav-taxonomies-names [iris]="[datalink.country]"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Location: </strong>
                {{datalink.location | isavGeoLocation}}
            </p>
            <p><strong>Acronym: </strong> {{ datalink.acronym }}</p>
            <p><strong>Subtitle: </strong> {{ datalink.subtitle }}</p>
            <p>
                <strong>Attachments:&nbsp;</strong>
                <isav-files-link [iris]="datalink.attachments"></isav-files-link>
            </p>
            <h2 class="title is-1 mt-6">Data-Link details</h2>
            <isav-description-display
                [title]="datalink.fullNameOfDataSet || ''"
                [content]="datalink.description"
            ></isav-description-display>
        </div>
        <div isavContentTypeAside>
            <isav-contact-information
                [contactName]="datalink.contactName"
                [contactEmail]="datalink.contactEmail"
                [contactPhone]="datalink.contactPhone"
            ></isav-contact-information>
            <img
                *ngIf="datalink.image"
                [isavApiImg]="datalink.image"
                alt=""
                aria-hidden="true"
                class="is-fullwidth is-containing is-max-vh"
            />
            <isav-image-caption [iri]="datalink.image"></isav-image-caption>
        </div>
    </isav-content-type-view>

    <isav-page-content>
        <isav-domain-event-journal-list [iri]="datalink['@id']"></isav-domain-event-journal-list>
    </isav-page-content>
</ng-container>
